import {
  DROP_DATA,
  SET_DATA,
  SET_FILTERS,
  SET_LOADING,
  SET_SORTING,
} from 'modules/AccountsMarketplace/Category/types'
import setFilters from 'store/reducer-utils/setFilters'
import { updateObject } from 'utils/updateObject'

const initialState = {
  loading: true,
  orders: [],
  filters: null,
  sorting: {
    prop: 'order_created_at',
    direction: 'asc',
  },
  pagination: {
    offset: 0,
    limit: 50,
    total: 0,
  },
}

const accountsMarketplaceCategorySetFilter = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
        (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
      )
    : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const setLoading = (state, { payload }) => updateObject(state, payload)

const setOrders = (state, { payload }) =>
  updateObject(state, {
    ...state,
    pagination: payload.pagination,
    orders: [...state.orders, ...payload.list],
    loading: false,
  })

const setSorting = (state, { payload }) =>
  updateObject(state, { sorting: payload })

const dropList = (state) =>
  updateObject(state, {
    orders: [],
    loading: true,
  })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FILTERS:
      return accountsMarketplaceCategorySetFilter(state, action)
    case SET_DATA:
      return setOrders(state, action)
    case SET_LOADING:
      return setLoading(state, action)
    case SET_SORTING:
      return setSorting(state, action)
    case DROP_DATA:
      return dropList(state)
    default:
      return state
  }
}

export default reducer
